import ajax from '@/utils/ajax';

const head = '/web';

// 获取用户前台订单分页列表
export const reqOrderList = (data) => ajax(`${head}/v1/order/list/front?pageNum=${data.pageNum}&pageSize=${data.pageSize}&status=${data.status}`);

// 取消订单
export const reqCancelOrder = (data) => ajax(`${head}/v1/order/cancel-order/${data}`);

// 我的订单详情
export const reqOrderDetail = (data) => ajax(`${head}/v1/order/order/detail?orderNo=${data}`);

// 添加收货地址
export const reqIndentAddress = (data) => ajax(`${head}/v1/order-address/address`, data, 'PUT');

// 修改收货地址
export const reqChangeIndent = (data) => ajax(`${head}/v1/order-address/${data.id}?userAddressId=${data.userAddressId}`, '', 'PUT');
